import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './components/HeroSection';
import ClientLogoBar from './components/ClientLogoBar';
import ValueProposition from './components/ValueProposition';


const Homepage = () => {
  return (
    <>
      <Helmet>
        <title>Mirakalous - Enterprise-Grade AI Services with Secure On-Prem & Cloud Deployments</title>
        <meta 
          name="description" 
          content="AI Solutions for Smarter Businesses. Custom AI consulting, deployment, infrastructure, model fine-tuning, and secure on-premise & cloud solutions. Trusted by Ford, Siemens, Citibank." 
        />
        <meta name="keywords" content="enterprise AI, secure AI architecture, on-premise AI, cloud AI, custom AI development, AI consulting, RAG systems, HPC deployment" />
        <meta property="og:title" content="Mirakalous - Enterprise-Grade AI Services with Secure Deployments" />
        <meta property="og:description" content="Custom AI solutions with secure on-premise & cloud deployments. Trusted by Fortune 500 companies." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/homepage-enterprise-ai-consulting-hub" />
      </Helmet>
      <div className="min-h-screen relative">
        {/* Content Layer (background now provided globally) */}
        <div className="relative z-10">

          <main className="pt-16">
            {/* Hero Section with Adaptive Messaging */}
            <HeroSection />

            {/* Client Logo Bar with Hover Details */}
            <ClientLogoBar />

            {/* Value Proposition removed per request */}

            {/* Metrics section removed per request */}



            
          </main>
          {/* Footer removed in favor of global footer */}
        </div>
      </div>
    </>
  );
};

export default Homepage;